module.exports = __webpack_public_path__ + "static/media/Draco-Malfoy.ac0e148f.png";